import {createStore} from "vuex";
import createPersistedState from "vuex-persistedstate";
import daily_messages from "@/helpers/daily_message.json";

export const store = createStore({
    state() {
        return {
            user: null,
            token: null,
            date: null,
            reportName: 'palourde',
            contractName: 'holothurie',
            contractTypes: null,
            paymentTypes: null,
            loyerMajores: null,
            termes: null,
            periodicities: null,
            prestations: null,
            labelDocuments: [],
            message: null,
            dateEdit: null,
            usedMessage: [],
            homepageMessage: null,
            partner: null,
            vr: [],
        }
    },
    mutations: {
        setUser(state, user) {
            state.user = user;
        },
        setToken(state, token) {
            state.token = token;
        },
        setDate(state, date) {
            state.date = date;
        },
        setReportName(state, reportName) {
            state.reportName = reportName;
        },
        setContractName(state, contractName) {
            state.contractName = contractName;
        },
        setContractTypes(state, contractTypes) {
            state.contractTypes = contractTypes;
        },
        setPayementTypes(state, paymentTypes) {
            state.paymentTypes = paymentTypes;
        },
        setLoyerMajores(state, loyerMajores) {
            state.loyerMajores = loyerMajores;
        },
        setTermes(state, termes) {
            state.termes = termes;
        },
        setPrestations(state, prestations) {
            state.prestations = prestations;
        },
        setPeriodicites(state, periodicities) {
            state.periodicities = periodicities;
        },
        setPartner(state, partner) {
            state.partner = partner;
        },
        setHomeMessages(state, homeMessages) {
            state.homepageMessage = homeMessages;
        },
        setLabelDocuments(state, labelDocuments) {
            state.labelDocuments = labelDocuments;
        },
        setDateEdit (state, date) {
            state.dateEdit = date;
        },
        setMessage (state, newMessage) {
            state.message = newMessage;
        },
        setUsedMessage(state, message) {
            state.usedMessage.push(message);
        },
        resetUsedMessage(state) {
            state.usedMessage = []
        },
        setPctVr(state, vr) {
            state.vr = vr;
        },
    },
    getters: {
        getUser(state) {
            return state.user;
        },
        getDate(state) {
            return state.date;
        },
        getToken(state) {
            return state.token;
        },
        getReportName(state) {
            return state.reportName;
        },
        getContractName(state) {
            return state.contractName;
        },
        getContractTypes(state) {
            return state.contractTypes;
        },
        getLabelDocuments(state) {
            return state.labelDocuments;
        },
        getMessage(state) {
            if(state.homepageMessage){
                return state.homepageMessage;
            }
            if (!state.dateEdit || (parseInt(new Date().getTime()/1000) - parseInt(new Date(state.dateEdit).getTime()/1000))/3600 > 23) {
                let message =  daily_messages.messages[Math.floor(Math.random() * daily_messages.messages.length)];

                if (daily_messages.messages.length === state.usedMessage.length) {
                    store.commit('resetUsedMessage')
                } else {
                    store.commit('setUsedMessage', state.message)
                    while (state.usedMessage.includes(message)) {
                        message =  daily_messages.messages[Math.floor(Math.random() * daily_messages.messages.length)];
                    }
                }
                store.commit('setDateEdit', (new Date()))
                store.commit('setMessage', message)
            }

            return state.message;
        },
        getAvailableMessage(state) {
            return state.usedMessage;
        },
        getPayementTypes(state) {
            return state.paymentTypes;
        },
        getLoyerMajores(state) {
            return state.loyerMajores;
        },
        getTermes(state) {
            return state.termes;
        },
        getPrestations(state) {
            return state.prestations;
        },
        getPeriodicites(state) {
            return state.periodicities;
        },
        getPartner(state) {
            return state.partner;
        },
        getPctVr(state) {
            return state.vr;
        }
    },
    plugins: [createPersistedState()]
})

